import ModalPanel from '@admin/components/modal_panel'
import PickList from '@admin/components/picklist'
import ServiceToken from '@admin/tokens/service'
import PropTypes from 'prop-types'
import React from 'react'

class New extends React.PureComponent {

  static propTypes = {
    options: PropTypes.array,
    onAdd: PropTypes.func,
    onBack: PropTypes.func
  }

  _handleBack = this._handleBack.bind(this)
  _handleChoose = this._handleChoose.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <PickList { ...this._getPickList() } />
      </ModalPanel>
    )
  }

  _getPickList() {
    const { options } = this.props
    return {
      options,
      onChoose: this._handleChoose,
      format: ServiceToken
    }
  }

  _getPanel() {
    return {
      title: 't(Choose Service)',
      leftItems: [
        { svg: 'chevron_left', handler: this._handleBack }
      ]
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChoose(service) {
    this.props.onAdd(service)
  }

}

export default New
